<template>
<div>
  <SideBar v-if="!isMobile" />
  <div :class="{ 'ml-80px': !isMobile }">
    <router-view />
  </div>
</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import SideBar from "@/components/SideBar.vue";

const isMobile = ref(window.innerWidth <= 768);

const handleResize = () => {
isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
window.removeEventListener('resize', handleResize);
});
</script>